import React, { FC } from 'react';

import { useFormikContext } from 'formik';

import styled from 'styled-components';

import aampeTheme from '../../constants/aampeTheme';

import UserAccessGroup from './UserAccessGroup';
import { EntityPermissionUserFormikContext, UserGroup } from './constant';

const AccessMembers: FC = () => {
    const { values, setFieldValue } =
        useFormikContext<EntityPermissionUserFormikContext>();

    const onClick = (role: UserGroup) => {
        setFieldValue('selectedGroup', role);
    };

    return (
        <Container>
            <Text>Who has access</Text>
            <UserGroupedList>
                <UserAccessGroup
                    title="Editors"
                    count={values.groups.editors.length}
                    onClick={onClick}
                    role={UserGroup.editors}
                />
                <UserAccessGroup
                    title="Managers"
                    count={values.groups.managers.length}
                    onClick={onClick}
                    role={UserGroup.managers}
                />
                <UserAccessGroup
                    title="Admins"
                    count={values.groups.admins.length}
                    onClick={onClick}
                    role={UserGroup.admins}
                />
            </UserGroupedList>
        </Container>
    );
};

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(4),
});

const Text = styled.span({
    color: aampeTheme.colors.textAccessibleWG01,
    fontSize: aampeTheme.size.font.default,
    fontWeight: aampeTheme.weights.medium,
    lineHeight: aampeTheme.size.lineHeight.default,
});

const UserGroupedList = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(4),
});

export default AccessMembers;
